import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

const propTypes = {
    selected: PropTypes.bool
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    height: 32,
    width: 32,
    keepPathColor: true
}

/**
 * Stateless function representing a temperature violation happened in the past.
 * Inline style is used to be able to render illustration as a standalone component.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <TemperatureViolationPastIllustration />
 */

const TemperatureViolationPastIllustration = props => {
    const { className, selected } = props
    const combinedClassnames = cx(className, 't3sel-temperature-violation-past-icon')

    const haloPath = 'M34,18c0,8.84-7.16,16-16,16S2,26.84,2,18S9.16,2,18,2S34,9.16,34,18z'
    const borderPath = 'M30,18c0,6.63-5.37,12-12,12S6,24.63,6,18S11.37,6,18,6S30,11.37,30,18z'
    const mark =
        'M19.2,24h-2.4v-2.4h2.4V24z M19.2,13.2c0-0.66-0.54-1.2-1.2-1.2s-1.2,0.54-1.2,1.2V18c0,0.66,0.54,1.2,1.2,1.2 s1.2-0.54,1.2-1.2V13.2z M12.53,20.93c0.29-0.29,0.29-0.77,0-1.06L10.66,18l1.87-1.87c0.29-0.29,0.29-0.77,0-1.06s-0.77-0.29-1.06,0 l-2.4,2.4c-0.29,0.29-0.29,0.77,0,1.06l2.4,2.4c0.15,0.15,0.34,0.22,0.53,0.22S12.38,21.08,12.53,20.93z'

    return (
        <SvgIcon viewBox="0 0 36 36" className={combinedClassnames} {...props}>
            {selected && <path fill="#ce0000" fillOpacity="0.25" d={haloPath} />}
            <path fill={selected ? '#ce0000' : '#ff3108'} d={borderPath} />
            <path fill="#ffffff" d={mark} />
        </SvgIcon>
    )
}

TemperatureViolationPastIllustration.defaultProps = defaultProps
TemperatureViolationPastIllustration.propTypes = propTypes

export { TemperatureViolationPastIllustration }
